export default __webpack_public_path__ + "static/media/bestseller2.8ae53f53.png";